<template>
  <div class="col">
    <div class="col-number">
      0{{ item.id }}
    </div>
    <div class="col-info">
      <div class="col-info__icon">
        <img v-bind:src=item.src alt="">
      </div>
      <div class="col-info__title">
        <mark>{{ item.name }}</mark>
      </div>
      <div class="col-info__text">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionStepsItem',
  props: {
    item: {
      item: {
        type: Object,
        required: true
      }
    }
  },
  components: {},
  methods: {},
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.col {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  box-sizing: border-box;
  margin-bottom: 20px;
  display: flex;
  @media (max-width: 1199.98px) {
    flex: 1 1 50%;
    max-width: 50%;
  }
  @media (max-width: 575.98px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
  &-number {
    padding-top: 30px;
    width: 100px;
    font-weight: 500;
    font-size: 4rem;
  }
  &-info {
    padding-left: 10px;
    flex: 1 1 auto;
    &__icon {
      width: 60px;
      height: 60px;
      position: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
    &__title {
      mark {
        margin-top: 20px;
        font-weight: bold;
        font-size: 2.2rem;
        padding: 6px 40px 6px 6px;
        display: inline-block;
        margin-bottom: 20px;
      }
    }
    &__text {
      font-size: 1.8rem;
    }
  }
}
</style>
